import { z } from "zod";

/**
 * Base ChatMessage schema and ChatMessageSenderType enum
 * Used by message-related endpoints
 */
export const ForgeChatMessageSenderType = z.enum([
  "User",
  "Agent",
  "Developer",
  "FunctionCallInput",
  "FunctionCallOutput",
]);
export type ForgeChatMessageSenderType = z.infer<typeof ForgeChatMessageSenderType>;

export const ForgeChatMessageSender = z.discriminatedUnion("type", [
  z.object({ type: z.literal(ForgeChatMessageSenderType.Values.User), userId: z.string() }),
  z.object({ type: z.literal(ForgeChatMessageSenderType.Values.Agent), persona: z.literal("Amy") }),
  z.object({ type: z.literal(ForgeChatMessageSenderType.Values.Developer) }),
  z.object({ type: z.literal(ForgeChatMessageSenderType.Values.FunctionCallInput) }),
  z.object({ type: z.literal(ForgeChatMessageSenderType.Values.FunctionCallOutput) }),
]);

export const ForgeChatMessage = z.object({
  id: z.string(),
  threadId: z.string(),
  payload: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  opikTraceId: z.string().optional(),
  sender: ForgeChatMessageSender,
});

export type ForgeChatMessageSender = z.infer<typeof ForgeChatMessageSender>;
export type ForgeChatMessage = z.infer<typeof ForgeChatMessage>;
